import { render, staticRenderFns } from "./dashboard-rank-picture-column.vue?vue&type=template&id=213e40b0&scoped=true&"
import script from "./dashboard-rank-picture-column.vue?vue&type=script&lang=js&"
export * from "./dashboard-rank-picture-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e40b0",
  null
  
)

export default component.exports